import { Dialog, Grid, SelectChangeEvent } from '@mui/material';
import { styles } from './styles';
import { ModalHeader } from 'pages/variants/common/modal-header';
import SearchSelect from 'components/select-components/search-select';
import { useGetSelectionVariantLibraryQuery } from 'redux-store/api/selection-variant';
import { useState } from 'react';
import ActionButton from 'components/buttons/index';
import { TVariantLibraryFormOption } from 'pages/variants/modals/variant-library-modal/types';

interface INewVariantModal {
  open: boolean;
  onClose: () => void;
  onSubmit: (options: TVariantLibraryFormOption[]) => void;
}

export const NewVariantModal = ({ open, onClose, onSubmit }: INewVariantModal) => {
  const [value, setValue] = useState<string | null>('');

  const { data, isLoading } = useGetSelectionVariantLibraryQuery();

  const hasNoData = !data?.items?.length;

  const renderValue = () => {
    if (hasNoData && !isLoading) return 'No Groups Available';

    if (value) {
      return data?.items.find((item) => item.id === Number(value))?.name;
    }

    return 'Select Group';
  };

  const onChange = (event: SelectChangeEvent<number>) => {
    setValue(`${event.target.value}`);
  };

  const handleSubmit = () => {
    const options = data?.items.find((library) => library.id === Number(value))?.options;

    if (options) {
      const optionsToSubmit = options.map((option) => ({
        name: option.name,
        orderNo: option.orderNo,
      }));

      onSubmit(optionsToSubmit);
    }
  };

  return (
    <Dialog open={open} sx={styles.dialog} onClose={onClose}>
      <ModalHeader
        heading="Import Choices"
        subheading="Select a pre-defined group of variant choices to be added."
      />
      <Grid sx={styles.content}>
        <SearchSelect
          disabled={hasNoData}
          renderValue={renderValue}
          options={data?.items.map((item) => ({ label: item.name, value: item.id }))}
          label="Groups"
          onChange={onChange}
          value={value}
        />

        <Grid sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', padding: '20px 0' }}>
          <ActionButton
            variant="secondary"
            type="button"
            label="Cancel"
            className="btn"
            onClick={onClose}
          />
          <ActionButton
            style={{ width: '123px' }}
            label={'Add'}
            disabled={!value}
            type="button"
            onClick={handleSubmit}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};
